import { useState } from "react";
import { Grid2 } from "@mui/material";
import TableCell from "../../CertificateTable/TableCell";
import SearchInput from "../../SearchInput";
import DownloadButton from "../../../containers/DownloadButton";
import ProductRow from "../ProductRow";

import classes from "../index.module.scss";
import { formatDate } from "../../../helpers/date";
import MaterialRow from "../../CertificateTable/MaterialRow";
import MaterialMemberArea from "../MaterialMemberArea";

const MemberAreaData = ({ company, isArchive = false }) => {
  const [search, setSearch] = useState('');
  const productList = company.productList
    .filter((product) => product.test_records.some((record) => record.certification_program?.id === 2))
    .filter((product) => {
      return !search || ~([
        (product.product_type?.productTypeName || '').toLowerCase(),
        (product.productName || '').toLowerCase(),
        ...(product.test_records || []).map((record) => [
          formatDate(record.testDate, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).replace(/\./ig, '-').toLowerCase(),
          (record.testMessage || '').toLowerCase(),
          (record.status || '').toLowerCase(),
        ].join(' '))
      ]).join(' ').indexOf(search.toLowerCase())
    });

  // filter out test records inside a product
  const filteredProductList = productList.map(
    (product) => {
      const result = {
        ...product,
        test_records: product.test_records.filter((record) => !!record.isArchive === !!isArchive)
      }

      if (result.test_records.length > 0) {
        return result;
      }
    }
  ).filter(Boolean);

  const materialBasedList = [
    // make sure without a material will be the first
    {
      name: '',
      productList: [],
    }
  ];

  filteredProductList.forEach((product) => {
    const materialName = (product.material?.name || '');
    let foundList = materialBasedList.find((material) => material.name === materialName);


    if (!foundList) {
      foundList = {
        name: materialName,
        productList: [],
      };

      materialBasedList.push(foundList)
    }

    foundList.productList.push(product);
  });



  return (
    <Grid2 container size={12} className={classes.memberTable}>
      <Grid2 container size={12}>
        <TableCell size={12} clearBorderBottom center fullWidth>
          <Grid2 container>
            <Grid2 container size={10}>
              <SearchInput onChange={setSearch} />
            </Grid2>
            <Grid2 container size={2}>
              <DownloadButton companyId={company.id} isReports isArchive={isArchive} />
            </Grid2>
          </Grid2>
        </TableCell>
        <Grid2 container size={12}>
          <Grid2 container size={6} className={classes.fullHeight}>
            <TableCell size={12} caption clearBorderBottom center className={classes.halfHeight}>
              Product
            </TableCell>
            <Grid2 container direction="row" size={12} className={classes.halfHeight}>
              <TableCell caption center size={6} clearBorderRight>Type</TableCell>
              <TableCell caption center size={6}>Name</TableCell>
            </Grid2>
          </Grid2>
          <TableCell size={1} caption center clearBorderLeft>Date</TableCell>
          <TableCell size={2} caption center clearBorderLeft>Message</TableCell>
          <TableCell size={1} caption center clearBorderLeft>Files</TableCell>
          <TableCell size={1} caption center clearBorderLeft>Test Report</TableCell>
          <TableCell size={1} caption center clearBorderLeft>Status</TableCell>
        </Grid2>
        {
          materialBasedList.map((material) => {
            return (
              <MaterialMemberArea
                key={material.name}
                material={material}
                company={company}
              />
            )
          })
        }
      </Grid2>
    </Grid2>
  )
}

export default MemberAreaData;